import classNames from 'classnames'
import { t } from '../../../../utils'
import styles from './_newPostButton.module.scss'
import { useState } from 'react'
import NewPostModal from './NewPostModal'
import { CommunityContext } from './CommunityLayout'
import { useLabLogin } from '../../../../utils/hooks/useLabLogin'

const NewPostButton = () => {
  const [postModalOpen, setPostModalOpen] = useState(false)

  const openPostModal = useLabLogin(CommunityContext, () =>
    setPostModalOpen(true)
  )

  return (
    <>
      <div className={styles.buttonContainer}>
        <button
          className={classNames('button lab-button', styles.newPostButton)}
          onClick={openPostModal}
        >
          {t('New Post')}
        </button>
      </div>

      {postModalOpen && (
        <NewPostModal onClose={() => setPostModalOpen(false)} />
      )}
    </>
  )
}

export default NewPostButton
